import { render, staticRenderFns } from "./FetchRemortgageFromApi.vue?vue&type=template&id=479638a0&"
import script from "./FetchRemortgageFromApi.vue?vue&type=script&lang=js&"
export * from "./FetchRemortgageFromApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports